import Objekt from '@/models/objekt';
import axios from 'redaxios';
import { v4 as uuidv4 } from 'uuid';

export const objektCreator = {
  data: () => ({
    // Set after navigating to the edit route, but never read anywhere; kept
    // declared so the assignments below and in consumers type-check.
    show: false
  }),

  methods: {
    async createNewProperty() {
      if (!this.$store.state.userdata?.id) {
        return this.$router
          .push({ name: 'login', query: { next: `/${this.$route.params.lang}/meineimmobilien` } })
          .catch(() => {});
      }
      const fields = Objekt.fields();
      const newMsid = uuidv4();
      const payload = {};
      for (const f in fields) {
        payload[f] = fields[f].value;
      }
      delete payload.uebersetzung;
      payload.msid = newMsid;
      payload.owner = this.$store.state.userdata.id;
      payload.flaechenbezeichnung = 'Neue Immobilie';
      payload.objektart = 180620000;
      payload.status = 100000000;
      payload.istabgelaufen = false;
      this.$store.dispatch('loading', true);
      try {
        const result = await axios.post('/api/objekt', payload);
        this.$store.dispatch('loading', false);
        Objekt.insert({ data: result.data });
        const backQuery = Object.assign({}, this.$route.query);
        this.$store.commit('backQuery', backQuery);
        const params = this.$route.params;
        params.objektId = result.data.id.toString();
        const query = Object.assign({}, this.$route.query);
        this.$router.push({ name: 'edit-objekt', params, query: Object.assign({}, query) }).catch(() => {});
        this.show = true;

        return result.data.id;
      } catch (error) {
        this.$store.dispatch('loading', false);
        this.$root.$confirm({
          title: this.$t('dialog.error').toString(),
          message: error.response?.data ? `${error.response.data.message}` : 'some unspecified error occured'
        });
      }
    }
  }
};
